/**
 * Feature flags for experimental features.
 * Flags are off by default so customers don't see unfinished features.
 */

import { AUTOMATIONS_FOOTER_ALL_ORGS, AUTOMATIONS_FOOTER_ORG_IDS } from '../config/automationsFooter.js'

function getUrlParam(name) {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(name)
}

/**
 * Whether the automations footer bar is enabled (experimental).
 * @param {string|null} orgId - Current organization ID (enables org-specific rollout)
 * Enabled when:
 *   - ?automationsFooter=1 or ?ff=automationsFooter (URL override for testing)
 *   - AUTOMATIONS_FOOTER_ALL_ORGS is true (src/config/automationsFooter.js)
 *   - orgId is in AUTOMATIONS_FOOTER_ORG_IDS (src/config/automationsFooter.js)
 */
export function isAutomationsFooterEnabled(orgId = null) {
  const urlParam = getUrlParam('automationsFooter') || getUrlParam('ff')
  if (urlParam === '1' || urlParam === 'automationsFooter') return true
  if (AUTOMATIONS_FOOTER_ALL_ORGS) return true
  if (orgId && AUTOMATIONS_FOOTER_ORG_IDS.length > 0) {
    return AUTOMATIONS_FOOTER_ORG_IDS.includes(orgId)
  }
  return false
}
